import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="newsletter-bloques"
//
// Inserta bloques visuales (botón / imagen) con estilo de marca fijo en el editor del
// cuerpo de la newsletter, sin que el editor tenga que escribir HTML (ENH-RNK-2331).
// El HTML del bloque lo renderiza el servidor (Newsletters::BloqueHtml); aquí solo se
// recogen los datos, se pide el HTML y se inserta en CKEditor.
export default class extends Controller {
  static values = { url: String, editorId: String }
  static targets = ['botonTexto', 'botonUrl', 'imagenUrl', 'imagenAlt']

  insertarBoton (event) {
    event.preventDefault()
    const texto = this.botonTextoTarget.value.trim()
    const url = this.botonUrlTarget.value.trim()
    if (!texto || !url) {
      window.alert('Indica el texto y la URL del botón')
      return
    }
    this.#insertar({ tipo: 'boton', texto, url }, () => {
      this.botonTextoTarget.value = ''
      this.botonUrlTarget.value = ''
    })
  }

  insertarImagen (event) {
    event.preventDefault()
    const url = this.imagenUrlTarget.value.trim()
    if (!url) {
      window.alert('Indica la URL de la imagen')
      return
    }
    this.#insertar({ tipo: 'imagen', url, alt: this.imagenAltTarget.value.trim() }, () => {
      this.imagenUrlTarget.value = ''
      this.imagenAltTarget.value = ''
    })
  }

  #insertar (params, onSuccess) {
    fetch(this.urlValue, {
      method: 'POST',
      body: new URLSearchParams(params),
      headers: { 'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content }
    }).then(response => response.text().then(body => {
      if (!response.ok) {
        window.alert(body || 'No se pudo insertar el bloque')
        return
      }
      this.#insertarEnEditor(body)
      onSuccess()
    })).catch(() => window.alert('No se pudo conectar para insertar el bloque'))
  }

  #insertarEnEditor (html) {
    const editor = typeof CKEDITOR !== 'undefined' && CKEDITOR.instances[this.editorIdValue]
    if (editor) {
      editor.insertHtml(html)
    } else {
      const textarea = document.getElementById(this.editorIdValue)
      if (textarea) textarea.value += `\n${html}\n`
    }
  }
}
